<!-- Container Card -->
<div
  class="bg-white dark:bg-coal-600 border border-gray-200 dark:border-coal-100 
         rounded-lg shadow-sm overflow-hidden h-full flex flex-col"
>
  <!-- Header -->
  <div
    class="px-6 py-4 border-b border-gray-200 dark:border-coal-100 
           text-lg font-semibold text-gray-800 dark:text-gray-100"
  >
    {{ accountname }}
  </div>

  <!-- Body -->
  <div class="card-body space-y-6">
  <kendo-grid
  [data]="view"
  [height]="533"
  [pageSize]="gridState.take"
  [skip]="gridState.skip"
  [sort]="gridState.sort"
  [pageable]="true"
  [sortable]="true"
  (edit)="editHandler($event)"
  (cancel)="cancelHandler($event)"
  (save)="saveHandler($event)"
  (remove)="removeHandler($event)"
  (add)="addHandler($event)"
  [navigable]="true"
>
  <ng-template kendoGridToolbarTemplate>
    <button kendoGridAddCommand>Add new</button>
  </ng-template>

  <kendo-grid-column field="clientNoteId" [hidden]="true"></kendo-grid-column>
  <kendo-grid-column field="clientId"    [hidden]="true"></kendo-grid-column>

  <!-- use editor="text" instead of "string" -->
  <kendo-grid-column field="note" editor="text" title="Note">
    <!-- optional edit template if you want a custom textbox -->
    <!--
    <ng-template kendoGridEditTemplate let-column="column" let-formGroup="formGroup">
      <input
        class="k-textbox k-adjust-width"
        [formControl]="formGroup.get(column.field)"
        maxlength="50"
        kendoTextBox
      />
    </ng-template>
    -->
  </kendo-grid-column>

  <kendo-grid-column field="modifiedBy" title="Modified By"></kendo-grid-column>

  <kendo-grid-column field="modifiedDate" title="Date">
    <ng-template kendoGridCellTemplate let-dataItem>
      {{ dataItem.modifiedDate | date:'MM/dd/yyyy hh:mm' }}
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-command-column title="" [width]="80">
    <ng-template kendoGridCellTemplate let-isNew="isNew">
      <button kendoGridEditCommand [primary]="true">Edit</button>
      <button kendoGridSaveCommand>
        {{ isNew ? 'Add' : 'Update' }}
      </button>
      <button kendoGridCancelCommand>
        {{ isNew ? 'Discard changes' : 'Cancel' }}
      </button>
    </ng-template>
  </kendo-grid-command-column>
</kendo-grid>

  </div>
</div>
